import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/ui/Modal';
import { WarningIcon } from 'components/ui/AlertBox/AlertBox.styles';

import { StyledCtaButtons } from '../AfterSalesCtas.styles';

import { TitleContainer, IconContainer, SubtitleContainer } from './WarningCta.styles';
import { CancelButton, ConfirmButton } from '../../../../../components/ui/Button';
import { StyledButtonWrapper } from '../ExchangeCta/ExchangeCtaOverride.styles';
import { ModalBottomRow } from '../../../../../components/ui/Modal/Modal.styles';
import WarningCtaMixedJourney from './WarningCtaMixedJourney';
import WarningCtaMultiplePF from './WarningCtaMultiplePF';

const WarningCta = ({
  label = '',
  title = '',
  subtitle = '',
  isPackageBooking = false,
  showConfirmButton = false,
  onConfirmClick,
  hasInsurance = false,
  hasMoreThanOneProductFamily = false,
  hasPassengersWithMixedJourneys = false,
  faresForPassengersInMixedJourney = {},
  productFamiliesPerPassengersInMixedPF = [],
  isMenuOpen = false
}) => {
  const [isOpen, toggleOpen] = useState(false);

  const openModal = () => toggleOpen(true);
  const closeModal = () => toggleOpen(false);

  return (
    <>
      <StyledCtaButtons
        type="button"
        data-testid="warning-cta"
        data-cy="warning-cta"
        label={label}
        onClick={openModal}
        isMenuOpen={isMenuOpen}
      >
        {label}
      </StyledCtaButtons>
      <Modal
        isOpen={isOpen}
        title={
          <TitleContainer>
            <IconContainer>
              <WarningIcon />
            </IconContainer>
            {title}
          </TitleContainer>
        }
        subtitle={<SubtitleContainer>{subtitle}</SubtitleContainer>}
        onClose={closeModal}
      >
        {isPackageBooking && (
          <div>
            <FormattedMessage id="exchanges.packageBookingSelected" /> - <FormattedMessage id="exchanges.packageBookingSameDepartureDate" />
          </div>
        )}
        {hasInsurance && (
          <div>
            <FormattedMessage id="exchanges.insuranceWarning.title" /> - <FormattedMessage id="exchanges.insuranceWarning" />
          </div>
        )}
        {hasPassengersWithMixedJourneys && <WarningCtaMixedJourney faresForPassengersInMixedJourney={faresForPassengersInMixedJourney} />}
        {hasMoreThanOneProductFamily && (
          <WarningCtaMultiplePF productFamiliesPerPassengersInMixedPF={productFamiliesPerPassengersInMixedPF} />
        )}
        {showConfirmButton && (
          <ModalBottomRow>
            <StyledButtonWrapper>
              <ConfirmButton data-testid="confirm-exchange-after-warning" data-cy="confirm-exchange-after-warning" onClick={onConfirmClick}>
                <FormattedMessage id="exchanges.confirm" />
              </ConfirmButton>

              <CancelButton
                type="button"
                data-cy="cancel-exchange-after-warning"
                data-testid="cancel-exchange-after-warning"
                onClick={closeModal}
              >
                <FormattedMessage id="exchanges.adandon" />
              </CancelButton>
            </StyledButtonWrapper>
          </ModalBottomRow>
        )}
      </Modal>
    </>
  );
};

WarningCta.propTypes = {
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  subtitle: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  isPackageBooking: PropTypes.bool,
  showConfirmButton: PropTypes.bool,
  onConfirmClick: PropTypes.func,
  hasInsurance: PropTypes.bool,
  hasMoreThanOneProductFamily: PropTypes.bool,
  hasPassengersWithMixedJourneys: PropTypes.bool,
  isMenuOpen: PropTypes.bool,
  faresForPassengersInMixedJourney: PropTypes.shape({
    singleFares: PropTypes.arrayOf(
      PropTypes.shape({
        passengerId: PropTypes.string,
        ticketNumber: PropTypes.string,
        passenger: PropTypes.shape({
          firstName: PropTypes.string,
          lastName: PropTypes.string
        })
      })
    ),
    returnFares: PropTypes.arrayOf(
      PropTypes.shape({
        passengerId: PropTypes.string,
        ticketNumber: PropTypes.string,
        passenger: PropTypes.shape({
          firstName: PropTypes.string,
          lastName: PropTypes.string
        })
      })
    )
  }),
  productFamiliesPerPassengersInMixedPF: PropTypes.arrayOf(
    PropTypes.shape({
      passengerId: PropTypes.string,
      ticketNumber: PropTypes.string,
      productFamily: PropTypes.string,
      passenger: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string
      })
    })
  )
};

export default WarningCta;
